"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'Advanced': 'Advanced',
            'Swatches': 'Swatches',
            'Apply': 'Apply',
            'Reset': 'Reset',
            'Hex': 'Hex'
        }
    },
    'es': {
        'translation': {
            'Advanced': 'Avanzado',
            'Swatches': 'Muestras de color',
            'Apply': 'Aplicar',
            'Reset': 'Reiniciar',
            'Hex': 'Hex'
        }
    },
    'cs': {
        'translation': {
            'Advanced': 'Pokročilé',
            'Swatches': 'Paleta',
            'Apply': 'Aplikovat',
            'Reset': 'Reset',
            'Hex': 'hexa'
        }
    },
    'zh': {
        'translation': {
            'Advanced': '进阶',
            'Swatches': '色盘',
            'Apply': '应用',
            'Reset': '重置',
            'Hex': '十六进制'
        }
    },
    'he': {
        'translation': {
            'Advanced': 'מתקדם',
            'Swatches': 'דוגמיות',
            'Apply': 'החל',
            'Reset': 'איפוס',
            'Hex': 'הקס'
        }
    }
};
